module.exports = __webpack_public_path__ + "img/1513953679.cb3eadd1.jpg";